module.exports = __webpack_public_path__ + "img/grade7.cfddaba6.jpg";